const th = {
  hello: 'สวัสดี',
  town: { label: 'เมือง' },
  portal: { label: 'พอล์ทัล' },
  home: { label: 'หน้าแรก' },
  picture: { label: 'รูปภาพ' },
  name: { label: 'ชื่อ' },
  position: { label: 'ตำแหน่ง' },
  contact: { label: 'ติดต่อ' },
  contributor: { label: 'ผู้เขียน' },
  modifiedDate: { label: 'เวลาแก้ไข' },
  galleryImage: { label: 'รูปภาพแกลลอรี่' },
  linkImage: { label: 'รูปภาพลิงค์' },
  profileImage: { label: 'รูปภาพโปรไฟล์' },
  default: {
    title: { label: 'หัวข้อ' },
    seq: { label: 'ลำดับ' },
  },
  alert: {
    deleteImage: { label: 'แน่ใจใช่ไหมที่จะลบรูปนี้ ?' },
  },
  actions: {
    create: { label: 'สร้าง' },
    save: { label: 'บันทึก' },
    delete: { label: 'ลบ' },
    copy: { label: 'คัดลอก' },
    add: { label: 'เพิ่ม' },
    edit: { label: 'แก้ไข' },
    search: { label: 'ค้นหา' },
    cancel: { label: 'ยกเลิก' },
    replace: { label: 'แทนที่' },
    clear: {label: 'ล้าง'},
    uploadImage: { label: 'อัปโหลดรูปภาพ' },
  },
  info: {
    label: 'ข้อมูลทั่วไป',
    title: {
      label: 'หัวข้อ',
      placeholder: 'หัวเรื่องของคุณ',
    },
    description: {
      label: 'รายละเอียด',
      placeholder: 'บรรยายรายละเอียดของคุณ',
    },
    tags: {
      label: 'แท็ก',
      placeholder: 'ใส่แท็กที่น่าสนใจของคุณ',
    },
    shortDescription: {
      label: 'รายละเอียดสั้น',
      placeholder: 'ใส่่คำจำกัดความของคุณ',
    },
    highlightSentence: {
      label: 'ไฮไลท์',
      placeholder: 'อธิบายจุดเด่น/สิ่งที่น่าสนใจของคุณ',
    },
    editorNotes: {
      label: 'ผู้เขียน',
      placeholder: 'ใส่ชื่อผู้เขียน/แหล่งที่มาของข้อมูล',
    },
    openingHours: {
      label: 'เวลาทำการ',
      placeholder: 'Ex. เปิดบริการทุกวัน 17:00 - 01:00 น.',
    },
    location: {
      streetAddress: {
        label: 'ที่อยู่',
      },
    },
  },
  contacts: {
    label: 'ข้อมูลติดต่อ',
    email: {
      label: 'อีเมล์',
      placeholder: 'ใส่อีเมลของคุณ',
    },
    phone: {
      label: 'เบอร์โทรศัพท์',
      placeholder: 'ใส่่เบอร์โทรศัพท์ของคุณ (สามารถใส่ได้มากกว่า 1 เบอร์)',
    },
    fanpage: {
      label: 'เฟสบุคแฟนเพจ',
      placeholder: 'ใส่เฟสบุ้คแฟนเพจของคุณ',
    },
    fbPageId: {
      label: 'เพจไอดี',
      placeholder: 'เพจไอดี เพื่อใช้ ปลั๊กอินแชทกับลูกค้า',
    },
    messengerId: {
      label: 'Messenger Id',
      placeholder: 'Messenger ID',
    },
    lineId: {
      label: 'ไลน์ไอดี',
      placeholder: 'ใส่ไอดีไลน์ของคุณ',
    },
    instragramId: {
      label: 'อินสตาแกรม',
      placeholder: 'ใส่ไอดีอินสตาแกรมของคุณ',
    },
    webpage: {
      label: 'เว็บ',
      placeholder: 'ใส่ลิงค์เว็บไซต์ของคุณ',
    },
    others: {
      label: 'อื่นๆ',
      placeholder: 'ใส่ช่องทางการติดต่ออื่นๆ(ถ้ามี)',
    },
  },
  place: {
    label: 'สถานที่',
    latitude: {
      label: 'ละติจูด',
      placeholder: 'ใส่ละติจูด',
    },
    longitude: {
      label: 'ลองจิจูด',
      placeholder: 'ใส่่ลองจิจูด',
    },
    streetAddress: {
      label: 'ข้อมูลที่อยู่',
      placeholder: 'ใส่ข้อมูลที่อยู่ของคุณ',
    },
    currentPosition: {
      label: 'ตำแหน่งปัจจุบัน',
    },
  },
  imageManagement: { label: 'จัดการรูปภาพ' },
  export: { label: 'ส่งออก' },
}
export default th



// WEBPACK FOOTER //
// ./src/modules/i18n/resources/th.js